export class ValidationHelpers {
	static isNumeric(value: any) {
		return !isNaN(parseFloat(value)) && isFinite(value);
	}

	static isPhoneNumber(value: any) {
		const phoneNumberRegex = /^[0-9]{10}$/;
		return phoneNumberRegex.test(value);
	}

	static isAchBankAccountNumber(value: any) {
		const achNumberRegex = /^[\d]{5,17}$/;
		return achNumberRegex.test(value);
	}

	// returns the numbers of the phone number by removing all formatting.
	static sanitizePhoneNumber(value: any) {
		if (!value) {
			return value;
		}

		return value.replace(/[^0-9]/g, '');
	}

	static isZipCode(value) {
		return value.match(/^\d{5}(?:[-\s]?\d{4})?$/);
	}

	static isOnlyDigits(value) {
		for (let ii = 0; ii < value.length; ++ii) {
			if (value.charAt(ii) < '0' || value.charAt(ii) > '9') {
				return false;
			}
		}
		return true;
	}

	static isEmailAddress(value) {
		return value.match(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/);
	}

	static isTransitNumber(value) {
		if (value.length !== 9) {
			return false;
		}
		if (!this.isOnlyDigits(value)) {
			return false;
		}
		let sum =
			parseInt(value[0]) * 3 +
			parseInt(value[1]) * 7 +
			parseInt(value[2]) * 1 +
			parseInt(value[3]) * 3 +
			parseInt(value[4]) * 7 +
			parseInt(value[5]) * 1 +
			parseInt(value[6]) * 3 +
			parseInt(value[7]) * 7 +
			parseInt(value[8]) * 1;
		return (sum % 10) === 0;
	}

	static isValidCreditCardNumber(value: any) {
		// perform luhm check
		let inputNum = value.toString();
		let sum = 0;
		let doubleUp = false;

		/* from the right to left, double every other digit starting with the second to last digit.*/
		for (let i = inputNum.length - 1; i >= 0; i--) {
			let curDigit = parseInt(inputNum.charAt(i), 10);

			/* double every other digit starting with the second to last digit */
			if (doubleUp) {
				/* doubled number is greater than 9 than subtracted 9 */
				if ((curDigit * 2) > 9) {
					sum += (curDigit * 2) - 9;
				}
				else {
					sum += curDigit * 2;
				}
			}
			else {
				sum += curDigit;
			}
			doubleUp = !doubleUp;
		}

		/* sum and divide it by 10. If the remainder equals zero, the original credit card number is valid.  */
		return (sum % 10) == 0 ? true : false;
	}

	// Validates credit card expiration date given a 4 digit value expressed as MMYY.
	static isValidExpirationDate(value: any) {
		if (!value) {
			return false;
		}

		let expirationMonth = value.substring(0, 2);
		let expirationYear = value.substring(2) % 100;

		let today = new Date();
		let currentYear = today.getFullYear() % 100;
		let currentMonth = (today.getMonth() + 1).toString().length < 2
			? ('0' + (today.getMonth() + 1).toString())
			: (today.getMonth() + 1).toString();

		if (expirationYear < currentYear) {
			return false;
		}

		if ((expirationYear === currentYear) && (expirationMonth < currentMonth)) {
			return false;
		}

		return true;
	}

	static isValidUsername(value: any) {
		const usernameRegex = /^[a-zA-Z0-9._@]+$/;
		return usernameRegex.test(value);
	}

	// Validates billing name consists of a two part (first and last) name.
	static isValidBillingName(value: any) {
		try {
			if (!value || value.length === 0) {
				return false;
			}

			const billingNameRegex = /[A-Za-z] +[A-Za-z]/;
			return billingNameRegex.test(value);
		}
		catch (err) {
			console.error('Error validating billing name.');
			return false;
		}
	}

	static isStrongPassword(password: any) {
		let valid = true;

		if (password.length < 12) { valid = false; }

		let containsAmpersand = new RegExp('[&]');

		if (containsAmpersand.test(password)) { valid = false; }

		let atLeastOneLowerCase = new RegExp('[a-z]+');
		let atLeastOneUpperCase = new RegExp('[A-Z]+');
		let atLeastOneNumber = new RegExp('[0-9]+');
		let atLeastOneSpecialCharacter = new RegExp('[@$!%*?]+');

		let score = 0;
		if (atLeastOneLowerCase.test(password)) { score++; }
		if (atLeastOneUpperCase.test(password)) { score++; }
		if (atLeastOneNumber.test(password)) { score++; }
		if (atLeastOneSpecialCharacter.test(password)) { score++; }
		if (score < 3) { valid = false; }

		return valid;
	}
}
